export const suggestionToOptimistic = ({
  payload,
  process,
  prices,
  total,
  product_type: productType,
  suggestionId,
  metadatas
}) => {
  return {
    id: suggestionId,
    identifier: suggestionId,
    payload,
    process,
    productType,
    prices,
    total,
    priceBeforeTaxes: total.before_taxes,
    priceAfterTaxes: total.after_taxes,
    metadatas
  };
};
export const suggestionToProductData = ({
  payload,
  process,
  product_type,
  suggestionId,
  metadatas
}) => ({
  identifier: suggestionId,
  payload,
  process,
  product_type,
  metadatas
});